/**
 * Text reveal — word opacity scrub on scroll.
 *
 * @package HelloElementorChild
 */

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { prefersReducedMotion } from './camst-counter.js';
import { initCamstReveal, teardownCamstReveal } from './camst-reveal.js';

gsap.registerPlugin(ScrollTrigger);

var textRevealInstances = new WeakMap();

export function initCamstTextReveal(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-text-reveal]'));
  } else if (scope.matches && scope.matches('[data-camst-text-reveal]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-text-reveal]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstTextRevealInit === '1') {
      return;
    }

    root.dataset.camstTextRevealInit = '1';
    initCamstReveal(root);

    var body = root.querySelector('[data-camst-text-reveal-body]');
    var words = root.querySelectorAll('[data-camst-text-reveal-word]');

    if (!body || !words.length) {
      return;
    }

    if (prefersReducedMotion()) {
      words.forEach(function (word) {
        word.style.opacity = '1';
      });
      return;
    }

    var ctx = gsap.context(function () {
      gsap.to(words, {
        opacity: 1,
        ease: 'none',
        stagger: 0.1,
        scrollTrigger: {
          trigger: body,
          start: 'top 75%',
          end: 'bottom 60%',
          scrub: 1,
        },
      });
    }, root);

    textRevealInstances.set(root, ctx);
  });
}

export function teardownCamstTextReveal(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-text-reveal]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-text-reveal]'));

  roots.forEach(function (root) {
    var ctx = textRevealInstances.get(root);

    if (ctx) {
      ctx.revert();
      textRevealInstances.delete(root);
    }

    teardownCamstReveal(root);
    delete root.dataset.camstTextRevealInit;
  });
}

export function refreshCamstTextReveal() {
  ScrollTrigger.refresh();
}
